module.exports = require("redux-first-history");